module.exports = __webpack_public_path__ + "static/media/HomeRoll_Walls_StoneWall.785d7eb1.jpg";